export default {
  unavailable: {
    title: 'O acesso self-serve de parceiros é limitado',
    description:
      'Esta secção não está disponível para parceiros em onboarding self-service. Contacte o seu gestor de conta se necessitar.',
  },
};
